
<div class="col-12 text-center"><img src="../../../assets/images/emblem.png" class="emblem" /></div>
<div class="col-12 text-center"><a href="https://www.facebook.com/angelcrypt/photos/a.10152961900023906/10160092655918906" target="_blank"><img src="../../../assets/images/nominee.png" class="nominee" /></a></div>

<!-- <div class="col-12 text-center legacy"><a href="https://angelcrypt.bandcamp.com/"><img src="../../../assets/images/legacy.gif" /></a></div> -->

<div class="parallax">

<div class="container">
  <div class="row text-center">
    <!--emblem-->
    <div class="col-12 text-center"><img src="../../../assets/images/emblem.png" class="emblem-mobile" /></div>

    <div class="col-12 spacer spacerMobile"></div>

    <!--facebook-->
    <!-- <div class="col-md-6"> -->
        <!-- <div class="fb-page" data-href="https://www.facebook.com/Angelcrypt" data-width="450" data-height="500" data-tabs="timeline" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true"><blockquote cite="https://www.facebook.com/Angelcrypt" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/Angelcrypt">Angelcrypt</a></blockquote></div> -->
    <!-- </div> -->

    <!--instagram-->
    <!-- <div class="col-md-6"> -->
      <!-- <div id="instafeed" style="text-align: center"></div> -->
      <!-- <iframe width="100%" height="500" src="https://www.youtube.com/embed/WaBUgeDWrwE?showinfo=0&autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe> -->
    <!-- </div> -->

    <div class="col-12 spacer spacerMobile"></div>

    <!--youtube main vidz-->
    <div class="col-md-6">
      <iframe width="100%" height="500" src="https://www.youtube.com/embed/-PZmovSsVes?showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </div>
    <div class="col-md-6">
      <iframe width="100%" height="500" src="https://www.youtube.com/embed/WZue1PrLOaE?showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </div>

    <div class="col-12 spacer"></div>

    <!--youtube sub vidz-->
    <div class="col-md-6">
      <iframe width="100%" height="500" src="https://www.youtube.com/embed/SYznLWVB0bQ?showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </div>
    <div class="col-md-6">
      <iframe width="100%" height="500" src="https://www.youtube.com/embed/sRMZ8XpnSh0?showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </div>

    <div class="col-12 spacer"></div>

    <div class="col-md-6">
      <iframe width="100%" height="500" src="https://www.youtube.com/embed/3mNCnEflsKM?showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </div>
    <div class="col-md-6">
      <iframe width="100%" height="400" src="https://www.youtube.com/embed/ZyhNPmQzlP4?showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </div>

    <div class="col-12 spacer"></div>

    <div class="col-md-6">
      <div class="fb-page" data-href="https://www.facebook.com/Angelcrypt" data-width="450" data-height="500" data-tabs="timeline" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true"><blockquote cite="https://www.facebook.com/Angelcrypt" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/Angelcrypt">Angelcrypt</a></blockquote></div>
    </div>
    <div class="col-md-6">
      <iframe width="100%" height="400" src="https://www.youtube.com/embed/sW4Ubfmy7MA?showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
  </div>

  <div class="col-12 spacer"></div>

    <!--spotify-->
    <div class="col-md-12">
        <iframe src="https://open.spotify.com/embed/artist/0gXROzYDbCZFNgke8uasuv" width="100%" height="380" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>
    </div>

    <div class="col-12 spacer"></div>

    <!--bandcamp merch-->
    <!-- <div class="col-md-12">
        <iframe src="https://angelcrypt.bandcamp.com/merch" width="100%" height="500" frameborder="0"></iframe>
    </div> -->

    <div class="col-12 spacer"></div>
  </div>
</div>
</div>


